import { useState,useEffect } from "react";
import axios from "axios";

function AddManager({onClose}) {

const [username,setUsername]=useState("");
const [email,setEmail]=useState("");
const [password,setPassword]=useState("");

const [employeeCode,setEmployeeCode]=useState("");
const [mobile,setMobile]=useState("");
const [departmentId,setDepartmentId]=useState("");
const [designationId,setDesignationId]=useState("");

const [departments,setDepartments]=useState([]);
const [designations,setDesignations]=useState([]);

useEffect(()=>{

loadDepartments();
loadDesignations();

},[]);

const loadDepartments=async()=>{

try{

const token=
localStorage.getItem("token");

const response=
await axios.get(

"https://saleupcall.com/api/Department/get-departments.php",

{
headers:{
Authorization:`Bearer ${token}`
}
}

);

if(response.data.status){

setDepartments(
response.data.data || []
);

}

}
catch(error){

console.log(error);

}

};

const loadDesignations=async()=>{

try{

const token=
localStorage.getItem("token");

const response=
await axios.get(

"https://saleupcall.com/api/Designation/get-designations.php",

{
headers:{
Authorization:`Bearer ${token}`
}
}

);

if(response.data.status){

setDesignations(
response.data.data || []
);

}

}
catch(error){

console.log(error);

}

};

const saveManager=async(e)=>{

e.preventDefault();

try{

const token=
localStorage.getItem("token");

const response=
await axios.post(

"https://saleupcall.com/api/Manager/add-manager.php",

{

username,
email,
password,

employee_code:employeeCode,
mobile,
department_id:departmentId,
designation_id:designationId

},

{
headers:{
Authorization:`Bearer ${token}`
}
}

);

if(response.data.status){

alert("Manager Added");

setUsername("");
setEmail("");
setPassword("");

setEmployeeCode("");
setMobile("");
setDepartmentId("");
setDesignationId("");

if(onClose){

onClose();

}

}
else{

alert(response.data.message);

}

}
catch(error){

console.log(error);

}

};

return(

<form onSubmit={saveManager}>

<h5 className="mb-3">
Login Details
</h5>

<div className="row">

<div className="col-md-4 mb-2">
<input type="text" className="form-control form-control-sm" placeholder="Username" value={username} onChange={(e)=>setUsername(e.target.value)} />
</div>

<div className="col-md-4 mb-2">
<input type="email" className="form-control form-control-sm" placeholder="Email" value={email} onChange={(e)=>setEmail(e.target.value)} />
</div>

<div className="col-md-4 mb-2">
<input type="password" className="form-control form-control-sm" placeholder="Password" value={password} onChange={(e)=>setPassword(e.target.value)} />
</div>

</div>

<hr/>

<h5 className="mb-3">
Manager Details
</h5>

<div className="row">

<div className="col-md-6 mb-2">

<input type="text" className="form-control form-control-sm" placeholder="Employee Code" value={employeeCode} onChange={(e)=>setEmployeeCode(e.target.value)} />

</div>

<div className="col-md-6 mb-2">

<input type="text" className="form-control form-control-sm" placeholder="Mobile" value={mobile} onChange={(e)=>setMobile(e.target.value)} />

</div>

<div className="col-md-6 mb-2">

<select className="form-select form-select-sm" value={departmentId} onChange={(e)=>setDepartmentId(e.target.value)}>

<option value="">
Select Department
</option>

{
departments.map((item)=>(

<option key={item.id} value={item.id}>
{item.department_name}
</option>

))
}

</select>

</div>

<div className="col-md-6 mb-2">

<select className="form-select form-select-sm" value={designationId} onChange={(e)=>setDesignationId(e.target.value)}>

<option value="">
Select Designation
</option>

{
designations.map((item)=>(

<option key={item.id} value={item.id}>
{item.designation_name}
</option>

))
}

</select>

</div>

</div>

<div className="text-end mt-1">

<button type="submit" className="btn btn-primary btn-sm">

<i className="bi bi-check-lg me-1"></i>

Save Manager

</button>

</div>

</form>

);

}

export default AddManager;